import React, { useEffect, useRef, useState } from 'react'
import HeaderComponent from '../Header/HeaderComponent'
import { getEventActually } from '../../services/EventServices';
import { MessageSquare, Send } from "lucide-react"
import FooterComponent from '../Footer/FooterComponent';
import { io } from 'socket.io-client';
import { ModalQuestions } from '../Modal/ModalComponent';
import { useLocation } from 'react-router-dom';

const ChatLiveComponent = () => {
  const location = useLocation();
  const [dataEvent, setDataEvent] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const socketRef = useRef(null); // Usar useRef para almacenar la conexión

  const openModalHandler = () => {
    setOpenModal(true);
  };

  const closeModalHandler = () => {
    setOpenModal(false);
  };


  useEffect(() => {
    if (!socketRef.current) {
      socketRef.current = io('https://innovadorsocket.interactiva.net.co');

      socketRef.current.on('connect', () => {
        console.log('Socket conectado:', socketRef.current.id);

        if (location.pathname === '/chatLive') {
          socketRef.current.emit('join_page', { page: '/chatLive' });
        }
      });

      // Escuchar eventos
      socketRef.current.on('show_modal', () => {
        openModalHandler();
      });

      socketRef.current.on('close_modal', () => {
        closeModalHandler();
      });

      // Cleanup
      return () => {
        if (location.pathname === '/chatLive') {
          socketRef.current.emit('leave_page', { page: '/chatLive' });
        }

        socketRef.current.disconnect();
        socketRef.current = null;
      };
    }
  }, [location.pathname]);

  useEffect(() => {
    // Función para obtener los datos del evento
    const getData = async () => {
      try {
        const response = await getEventActually();
        setDataEvent(response.events);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    // Llamamos a getData una vez cuando el componente se monta
    getData();
  }, []); // La dependencia vacía asegura que esto se ejecute solo una vez

  const name = sessionStorage.getItem('name');
  const lastName = sessionStorage.getItem('last_name');

  const fullName = `${name} ${lastName}`;

  return (
    <>
      <div className="container-innovador min-h-screen flex flex-col">
        <HeaderComponent />
        {dataEvent.length === 0 ? (
          <div className="text-center">
            <p className="text-lg text-gray-600">No hay eventos disponibles en este momento.</p>
          </div>
        ) : (
          dataEvent.map((data, index) => (
            <div key={index} className="flex-grow flex items-center justify-center p-4">
              <div className="w-full max-w-2xl flex flex-col items-center space-y-4">
                <h1 className="text-2xl font-bold text-blue-800">Chat en vivo</h1>
                <p className="text-sm text-gray-600 flex text-center items-center justify-center">
                  <MessageSquare className="mr-2 h-4 w-4 text-blue-500" />
                  Sus inquietudes y comentarios son importantes para nosotros
                </p>
                <div className="w-full aspect-video">
                  <iframe
                    src={`https://e.interactiva.com.co/#/${data.url_chat}?name=Dr/a.${encodeURIComponent(fullName)}`}
                    title="Chat en vivo"
                    className="w-full h-full rounded-md shadow-md"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="w-full flex items-center justify-center bg-blue-100 rounded-md p-3">
                  <Send className="h-5 w-5 text-blue-500 mr-2" />
                  <span className="text-sm text-blue-700">Envíe su pregunta para participar en el chat</span>
                </div>
              </div>
            </div>
          ))
        )}

        <FooterComponent />
        <ModalQuestions showModal={openModal} closeModal={closeModalHandler} />
      </div>
    </>
  )
}

export default ChatLiveComponent